<template>
    <BaseDialog
    max_width="90%"
    :dialog="dialog"
    title="Visualizza i pesi selezionati"
    v-on:close_dialog="closeDialog">
    <div class="d-flex flex-column">
        <div v-for="(item,index) in itemsToShow" :key="index" class="d-flex ma-1">
            <span class="ma-2">Valore nominale: <span class="font-weight-bold">{{item.nom}} {{uom}}</span></span>  
            <div class="d-flex" v-if="item.converted.length > 0">
                <span class="ma-2">
                    ottenuto con
                </span>
                <div class="d-flex flex-column">
                    <div v-for="(weight, index) in item.converted" :key="index">
                        Massa con matricola: <span class="font-weight-bold">{{weight.weight._id}}</span>
                        Pesiera: <span class="font-weight-bold">{{weight.primary.name}}</span>
                    </div>
                </div>
                
            </div>
            <div class="d-flex ma-2" v-else>
                <span class="text-h6">
                    Non è stato ancora selezionato alcun peso
                </span>
            </div>
        </div>
        <div class="d-flex justify-center ma-2">
            <v-btn text @click="closeDialog">Chiudi</v-btn>
        </div>
    </div>
    </BaseDialog>
</template>
<script>
import BaseDialog from '../dialogs/BaseDialog'
export default {
    components: {BaseDialog},
    data() {
        return {
            dialog: false,
            itemsToShow: [],
            uom: ""
        }
    },
    methods: {
        openDialog(items, primaries, uom){
            // console.log("$$debug: items passed", items)
            this.uom = uom
            this.itemsToShow.splice(0, this.itemsToShow.length)
            for(let item of items){
                if(item.nom){
                    let converted = []
                    if(item.weights.length > 0) {
                        converted = this.getPrimaryFromWeights(item.weights, primaries)
                        // console.log("$$debug: items converted", items)
                    }
                    let itemToShow = {
                        nom: item.nom,
                        converted: converted
                    }
                    this.itemsToShow.push(itemToShow)
                }
            }
            this.dialog = true
        },
        getPrimaryFromWeights(weights, primaries){
            let primariesAndWeights = []
            weights.forEach(item => {
                let primary = primaries.find(element => {
                    return element._id == item.weightSet
                })
                // console.log("$$debug: found primary in conversion", primary, item)
                if (primary) {
                    let weight = primary.primary_data.data.values.find(element => {
                        return element._id == item.mass
                    })
                    let newItem = {
                        primary: primary,
                        weight: weight
                    }
                    primariesAndWeights.push(newItem)
                }
            })
            return primariesAndWeights
        }, 
        closeDialog(){
            this.dialog = false
        },
    },
}
</script>